import React from "react";
import Modal from "react-modal";
import { Message } from "../cookies/Message";
class VideoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };

    this.body = document.querySelector("body");
  }

  componentWillMount() {
    const image = document.getElementById("video-modal-image");

    if (!image) return;

    image.addEventListener("click", () => {
      this.openModal();
    });
  }

  openModal = () => {
    this.setState({
      modalIsOpen: true,
    });

    this.body.classList.add("disable-scroll");
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });

    const base = window.location.toString().split("?")[0];

    history.pushState({}, "", base); // eslint-disable-line no-restricted-globals

    this.body.classList.remove("disable-scroll");
  };

  parseEmbedUrl = (url) => {
    if(url) {
      if (url.includes("watch?v=")) {
        return url.replace("watch?v=", "embed/");
      }

      if (url.includes("https://vimeo.com")) {
        return url.replace("vimeo.com", "player.vimeo.com/video");
      }
    return url;}
  };

  render = () => {
    const { modalIsOpen } = this.state;

    const image = document.getElementById("video-modal-image");

    return (
      <Modal
        className="modal"
        overlayClassName="modal__overlay"
        isOpen={modalIsOpen}
        onRequestClose={this.closeModal}
      >
        <button
          className="modal__close"
          type="button"
          onClick={this.closeModal}
        >
          <svg
            className="icon-small"
            viewBox="0 0 18 18"
            role="presentation"
            focusable="false"
          >
            <use xlinkHref="#icon-close" />
          </svg>
        </button>

        {/* Show this if user didn't agree with marketing cookies. */}
        <Message />

        <iframe
          title="Video"
          width="640"
          height="360"
          referrerpolicy="strict-origin-when-cross-origin"
          frameborder="0"
          src={this.parseEmbedUrl(image.dataset.videoSrc)}
          className="cookieconsent-optin-marketing"
        ></iframe>
      </Modal>
    );
  };
}

export default VideoModal;
